import React from "react";
import { useAuthContext } from "../../Auth/context/auth-context";

const StandardButton: React.FC = () => {
  const { isAuthenticated, user } = useAuthContext();
  const handleClick = () => {
    if (!isAuthenticated || !user?.is_trainer) {
      alert("Zaloguj się jako trener, aby wybrać pakiet.");
      return;
    }
    alert("Wybrano pakiet standard! Możesz teraz dodawać ogłoszenia.");
  };
  return (
    <button className={`btn btn-light`} onClick={handleClick}>
      Wybieram standard
    </button>
  );
};

export default StandardButton;
